<template>
  <div class="mobile_contentBox">
    <div class="contentStitle">Enterprise Information</div>
    <div class="contentTitle">企业资讯</div>
    <div class="introduction">
      <div class="introduction_title">云久鸿简介</div>
      <p class="introduction_text">
        深圳市云久鸿劳务派遣有限公司于2010年5月在深圳市龙华区成立，总部位于深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心，是一家专业的人力资源平台。
      </p>
      <p class="introduction_text">
        云久鸿始终秉持着诚信、责任、共赢、感恩的企业价值观，以用心服务，筑就行业新高度为使命，为打造值得全球信赖的就业服务平台而不懈努力。
      </p>
      <img :src="src.qyzx1" alt="" />
      <p class="introduction_text">
        经过10余年的发展，云久鸿已成为人力资源行业的领先企业，被深圳龙华区人民政府评定为服务业百强企业。
      </p>
      <p class="introduction_text">
        现设云久鸿劳务派遣有限公司、云久鸿人力资源有限公司、景上鸿劳务派遣有限公司、云富鸿人力资源有限公司、蓝聘人力资源有限公司等多家子公司，并在深圳各个区设立了多家线下门店。
      </p>
      <p class="introduction_text">
        迄今为止，公司已服务企业客户达500多家，为富士康、比亚迪、伯恩光学、天马微等多家500强名企输送数以万计的人力资源。现可日均输送人力达2000多人次，全年输送人力10余万人次。
      </p>
       <img :src="src.qyzx2" alt="" />
      <p class="introduction_text">云久鸿十分重视线上求职渠道的建设。</p>
      <p class="introduction_text">
        求职者只需进入《云久鸿人力》微信公众号、小程序，就能一键求职，操作更简单。
      </p>
      <p class="introduction_text">
        现可日均输送人力达2000多人次，全年输送人力10余万人次。
      </p>
        <img :src="src.qyzx3" alt="" />
    </div>
  </div>
</template>

<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
};
</script>

<style lang="less" scoped>
.introduction {
  width: 330px;
  margin: 0 auto;
  .introduction_title {
    font-size: 18px;
    font-weight: 700;
    margin: 10px 0;
  }
  .introduction_text {
    text-align: left;
    line-height: 20px;
  }
  img {
    width: 80%;
    margin: 10px 0;
  }
}
</style>
